module.exports = __webpack_public_path__ + "static/comantics.300dc6aa.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/papers/comantics.pdf
// module id = 389
// module chunks = 35783957827783